let offset = 50;
let anchorElement = document.querySelector('.block_anchor');
let anchorElementInner = document.querySelector('.block_anchor .inner');
let anchorElementTop = getOffset(anchorElement).top;
let anchorHeight = anchorElementInner.offsetHeight + 56;

if (document.body.clientWidth >= 1024) {
    offset = 0;
    anchorHeight = anchorElementInner.offsetHeight + 32;
}

document
    .querySelectorAll('.block_anchor .anchor')
    .forEach(trigger => {
        trigger.onclick = function (e) {
            e.preventDefault();
            let hash = this.getAttribute('href');
            let target = document.querySelector(hash);
            let offsetPosition = target.offsetTop - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        };
    });

function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
        top: rect.top + window.scrollY
    };
}

function fixedAnchorElement() {
    if ((window.pageYOffset + window.innerHeight) > anchorElementTop + anchorHeight) {
        anchorElementInner.classList.add('fixed');
    } else if (window.pageYOffset < (anchorElementTop)) {
        anchorElementInner.classList.remove('fixed');
    }
}

window.addEventListener('scroll', fixedAnchorElement);
